module.exports = __webpack_public_path__ + "static/media/logo_navbar_old.0bb47404.png";